import { useKanagawaPalette } from '@aid/theme';
import { HeroCardSkeleton, StandardCardSkeleton } from './AppCardSkeleton';

/**
 * Full-screen loading state shown while Keycloak initializes. Mirrors the
 * v2 catalog layout (chrome bar + hero text + hero/standard skeletons) so
 * the first paint matches the authenticated screen instead of flashing a
 * generic spinner.
 */
export function LoadingScreen() {
  const palette = useKanagawaPalette();

  return (
    <div className="hub-page" style={{ background: palette.base, color: palette.text }}>
      <header
        className="hub-chrome"
        style={{
          background: palette.base,
          borderBottom: `1px solid ${palette.surface1}`,
        }}
      >
        <div className="hub-chrome__inner" />
      </header>
      <main role="status" aria-label="Loading" className="hub-main">
        <div className="hub-hero" style={{ maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
          <span
            className="hub-shimmer"
            style={{
              display: 'inline-block',
              width: 'min(320px, 70%)',
              height: 36,
              borderRadius: 10,
              background: palette.surface1,
            }}
          />
          <div style={{ marginTop: 14 }}>
            <span
              className="hub-shimmer"
              style={{
                display: 'inline-block',
                width: 'min(240px, 60%)',
                height: 14,
                borderRadius: 7,
                background: palette.surface1,
              }}
            />
          </div>
        </div>
        <div className="hub-loading">
          <HeroCardSkeleton />
          <StandardCardSkeleton />
        </div>
      </main>
    </div>
  );
}
